import { z } from 'zod';

/////////////////////////////////////////
// CASE LOG SCHEMA
/////////////////////////////////////////

export const CaseLogSchema = z.object({
  caselogId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  staff: z.number().int(),
  infoOnly: z.number().int(),
  fromId: z.number().int(),
  toId: z.number().int(),
  message: z.string(),
  dateSent: z.coerce.date(),
  atachments: z.string(),
  externalId: z.string().nullable(),
  rowTimestamp: z.coerce.date(),
})

export type CaseLog = z.infer<typeof CaseLogSchema>

export default CaseLogSchema;
